import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const InfrastructureSection = () => {
  const [isHovered, setIsHovered] = useState(false);

  const infrastructureItems = [
    {
      title: "Advanced Storage Systems",
      description:
        "Multiple temperature-controlled environments including ambient, refrigerated (+2°C to +8°C), frozen (-20°C, -80°C), and liquid nitrogen vapor phase storage. Automated monitoring systems ensure sample integrity 24/7.",
      position: "left-[5%] top-[15%]",
      direction: -100, // Slide from left
    },
    {
      title: "Controlled Sample Processing Environment",
      description:
        "Purpose-built facilities for standardized sample processing, including aliquoting, cell isolation, and nucleic acid extraction—operating under strict environmental and biosafety controls.",
      position: "left-[5%] bottom-[15%]",
      direction: -100, // Slide from left
    },
    {
      title: "Diagnostic Testing Equipment",
      description:
        "Modern hematology analyzers, clinical chemistry systems, immunoassay platforms, and molecular testing equipment enable comprehensive diagnostic capabilities with rapid turnaround.",
      position: "right-[5%] top-[15%]",
      direction: 100, // Slide from right
    },
    {
      title: "Global Shipping & Logistics",
      description:
        "End-to-end logistics coordination with validated packaging, temperature-controlled conditions, and regulatory-aligned shipping practices to preserve sample integrity.",
      position: "right-[5%] bottom-[15%]",
      direction: 100, // Slide from right
    },
  ];

  return (
    <section className="w-full bg-[#F0F7FF] py-[50px] lg:py-[100px] overflow-hidden">
      <div className=" mx-auto px-4">
        {/* Section Title */}
        <div className="text-center mb-16">
          <h2
            className="text-[24px] md:text-[30px] lg:text-[40px] 2xl:text-[60px] font-bold text-[#002D62]"
            style={{ fontFamily: "Bricolage Grotesque" }}
          >
            State-of-the-Art Infrastructure
          </h2>
        </div>

        {/* Desktop Interactive Layout */}
        <div
          className="hidden lg:flex relative items-center justify-center"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {/* Center Image */}
          <motion.div
            className="z-20 cursor-pointer overflow-hidden rounded-[2rem] shadow-2xl border-4 border-white"
            animate={{
              width: isHovered ? "50%" : "80%",
              // scale: isHovered ? 0.9 : 1,
            }}
            transition={{ type: "spring", stiffness: 100, damping: 20 }}
          >
            <img
              src="/images/img_image_12.png"
              alt="Infrastructure"
              className="w-full h-[100vh] object-cover"
            />
          </motion.div>

          {/* Side Cards - Slide Animation */}
          {infrastructureItems.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: item.direction }}
              animate={{
                opacity: isHovered ? 1 : 0,
                x: isHovered ? 0 : item.direction,
                display: isHovered ? "block" : "block",
              }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
              className={`absolute ${item.position} max-w-[300px] md:max-w-[400px] 2xl:max-w-[690px] z-30`}
            >
              <div className="bg-white/80 backdrop-blur-md p-6 rounded-2xl shadow-xl border border-white/50">
                <h3
                  className="text-[20px] md:text-[24px] 2xl:text-[30px] font-bold text-[#002D62] mb-2"
                  style={{ fontFamily: "Bricolage Grotesque" }}
                >
                  {item.title}
                </h3>
                <p className="text-[16px] md:text-[18px] 2xl:text-[24px] leading-relaxed text-justify">
                  {item.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Mobile Layout */}
        <div className="lg:hidden grid grid-cols-1 gap-6">
          <img
            src="/images/img_image_12.png"
            className="rounded-xl mb-4"
            alt="Infrastructure"
          />
          {infrastructureItems.map((item, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-xl shadow-md border-l-4 border-blue-600"
            >
              <h3 className="font-bold text-[#002D62]">{item.title}</h3>
              <p className="text-sm text-gray-600 mt-2">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InfrastructureSection;
